import { useId, useState } from 'react';

export function ProjectCard({
  number,
  title,
  meta,
  description,
  results,
  tech = [],
  expandableContent,
}) {
  const [isOpen, setIsOpen] = useState(true);
  const panelId = useId();

  return (
    <article className="mb-16">
      <button
        type="button"
        onClick={() => setIsOpen((v) => !v)}
        aria-expanded={isOpen}
        aria-controls={panelId}
        className="min-h-[44px] w-full border-b border-gray-300 py-2 text-left font-mono text-sm text-black focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-white"
      >
        {title}
      </button>

      {isOpen && (
        <div id={panelId} className="mt-4">
          {meta && <p className="mb-4 font-mono text-sm text-gray-600">{meta}</p>}

          <div className="mb-4 space-y-4 font-mono text-sm leading-[1.7] text-black">
            {description}
          </div>

          {results && results.length > 0 && (
            <div className="mb-4">
              <p className="mb-2 font-mono text-sm text-gray-700">Key Results:</p>
              <ul className="ml-6 list-none space-y-1 font-mono text-sm">
                {results.map((item, i) => (
                  <li key={i} className="pl-0">
                    <span className="text-black">• {item}</span>
                  </li>
                ))}
              </ul>
            </div>
          )}

          {tech.length > 0 && (
            <p className="mb-4 font-mono text-sm text-gray-600">
              Tech: {tech.join(', ')}
            </p>
          )}

          {expandableContent && <div className="mt-6">{expandableContent}</div>}
        </div>
      )}
    </article>
  );
}
